// extracted by mini-css-extract-plugin
export default {"button":"BlockButton_button__g8YcN","link":"BlockButton_link__+UwTi"};